import markCompleteStyles from "../MarkAsCompleteHeader/MarkAsCompleteHeader.module.css";
import React from "react";
import {useTranslation} from "react-i18next";

interface Props {
    openModal: () => void;
}
export default function SubmitAllDocumentsHeader({
    openModal
}: Props) {
    const { t } = useTranslation("common");

    return <div className={markCompleteStyles.markAsCompleteHeader}>
        <div className={markCompleteStyles.submissionDate}></div>
        <div className={markCompleteStyles.markCompleteButtonWrapper}>
            <button
                className={markCompleteStyles.buttonColour}
                onClick={openModal}
                data-cy="submitAllDocumentsButton"
            >
                {t("inspection.submitAllDocumentsModal.button")}
            </button>
        </div>
    </div>
}